import {Component, OnInit} from '@angular/core';
import {ApiService} from '../api.service';
import {Postcard} from '../postcard';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})

export class SearchComponent implements OnInit {

  private api: ApiService;
  private postcards: Observable<Array<Postcard>> = null;
  private total: any = 0;
  private surname: String;
  private town: String;
  private from: String;
  private year: Number;
  private years: any;

  constructor(api: ApiService) {
    this.api = api;

    if (localStorage.getItem('surname') !== null) {
      // setup the previous parameters
      this.retrieveSearchParams();
      // search
      this.searchFromMemory();
    }

    if (localStorage.getItem('untranscribed') !== null) {
      this.getAllUntranscribedPostcards();
    }
  }

  ngOnInit() {
    this.getYears();
    this.countAllUntranscribedPostcards();
  }

  search = function () {
    localStorage.removeItem('untranscribed');
    this.api.getPostcards(this.surname != null ? this.surname : '', this.town != null ? this.town : '', this.from != null ? this.from : '', this.year != null ? this.year : '').subscribe(res => {

      // let's store these values
      this.storeSearchParams();

      this.postcards = res;
    });
  };
  storeSearchParams = function () {
    localStorage.setItem('surname', this.surname != null ? this.surname : '');
    localStorage.setItem('town', this.town != null ? this.town : '');
    localStorage.setItem('from', this.from != null ? this.from : '');
    localStorage.setItem('year', this.year != null ? this.year : '');
  };

  retrieveSearchParams = function () {
    if (localStorage.getItem('surname') !== null) {
      this.surname = localStorage.getItem('surname');
      this.town = localStorage.getItem('town');
      this.from = localStorage.getItem('from');
      this.year = localStorage.getItem('year');
    }
  };

  searchFromMemory = function () {
    if (localStorage.getItem('surname') !== null || localStorage.getItem('town') !== null || localStorage.getItem('from') !== null || localStorage.getItem('year') !== null) {
      this.api.getPostcards(localStorage.getItem('surname'), localStorage.getItem('town'), localStorage.getItem('from'), localStorage.getItem('year')).subscribe(res => {
        this.postcards = res;
      });
    }
  };

  getAllUntranscribedPostcards = function () {
    localStorage.setItem('untranscribed', '');
    this.api.getAllUntranscribedPostcards().subscribe(res => {
      this.postcards = res;
    });
  };

  countAllUntranscribedPostcards = function () {
    this.api.countAllUntranscribedPostcards().subscribe(res => {
      this.total = res.total;
    });
  };

  // clearSearchParams = function () {
  //   this.surname = null;
  //   this.town = null;
  //   this.from = null;
  //   this.years = null;
  //   this.year = null;
  // };

  clear = function () {
    // clean
    this.postcards = null;
    this.surname = null;
    this.town = null;
    this.from = null;
    this.years = null;
    this.year = null;

    localStorage.removeItem('surname');
    localStorage.removeItem('town');
    localStorage.removeItem('from');
    localStorage.removeItem('year');
    localStorage.removeItem('untranscribed');

    // bring back default data
    this.getYears();
  };

  checkSearchState = function () {
    return !((this.surname != null && this.surname !== '') || (this.town != null && this.town !== '') || (this.from != null && this.from !== '') || this.year != null);
  };

  checkClearState = function () {
    return this.postcards == null;
  };

  userSearching = function () {
    return (this.surname != null && this.surname !== '') || (this.town != null && this.town !== '') || (this.from != null && this.from !== '') || this.year != null;
  };

  updateUrl = function (event) {
    event.srcElement.src = environment.errors.missingImageURL;
  };

  getYears() {
    this.api.getYears().subscribe(res => {
      this.years = res;
      let found = false;
      if (localStorage.getItem('year') !== null) {
        this.years.filter(((val: any) => {
          if (`${val.year}` === `${localStorage.getItem('year')}`) {
            val.selected = true;
            found = true;
          }
        }));

        if (!found) {
          console.log('might be here');
          this.year = null;
          localStorage.removeItem('year');
        }
      }
    });
  }
}
